/* Pension Credit calculator screens. Uses calculator.js. No network, storage, or cookies. */
(function () {
  var pc = window.KTPensionCredit;
  var root = document.getElementById("kt-tool");
  if (!pc || !root) return;

  var PRIVACY = "Your answers stay on your device. We don't store them, ask for your name or contact details, or follow up.";
  var CLAIM = "Pension Credit claim line (free): 0800 99 1234, Monday to Friday, 8am to 6pm. You can call for yourself, or a friend or family member can call for you if you cannot use the phone.";
  var RELAY = "Relay UK: 18001 then 0800 99 1234. British Sign Language video relay is also available. Or apply online or by post on GOV.UK.";
  var whySeq = 0;
  var screen = "who";
  var stack = [];
  var state = blankState();

  function blankState() {
    return {
      who: "me",
      personSpa: null,
      couple: null,
      partnerSpa: null,
      housingBenefit: null,
      incomes: {
        sp: blankIncome(),
        other: blankIncome(),
        earn: blankIncome(),
        ben: blankIncome()
      },
      savingsRaw: "",
      savingsPence: 0,
      savingsOver: null,
      gate: null,
      followIndex: 0,
      extras: {},
      nation: "england",
      error: ""
    };
  }

  function blankIncome() {
    return { on: false, raw: "", period: "week" };
  }

  function voice() {
    var parent = state.who !== "me";
    return {
      You: parent ? "They" : "You",
      you: parent ? "they" : "you",
      Your: parent ? "Their" : "Your",
      your: parent ? "their" : "your",
      obj: parent ? "them" : "you",
      are: parent ? "they're" : "you're",
      Do: parent ? "Do they" : "Do you",
      Did: parent ? "Did they" : "Did you",
      YouLowerHave: parent ? "Have they" : "Have you",
      partner: parent ? "their partner" : "your partner",
      Partner: parent ? "Their partner" : "Your partner"
    };
  }

  function h(tag, attrs, text) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (key) {
        if (key === "class") node.className = attrs[key];
        else node.setAttribute(key, attrs[key]);
      });
    }
    if (text != null) node.textContent = text;
    return node;
  }

  function button(label, className, fn) {
    var node = h("button", { class: className, type: "button" }, label);
    node.addEventListener("click", fn);
    return node;
  }

  function formatPence(pence) {
    var n = Math.abs(pence);
    var pounds = Math.floor(n / 100);
    var rem = n % 100;
    var body = String(pounds).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var remText = rem < 10 ? "0" + rem : String(rem);
    return (pence < 0 ? "-£" : "£") + body + "." + remText;
  }

  function show(next) {
    stack.push(screen);
    screen = next;
    state.error = "";
    draw();
  }

  function back() {
    if (!stack.length) return;
    screen = stack.pop();
    state.error = "";
    draw();
  }

  function begin(who) {
    var nation = state.nation;
    state = blankState();
    state.who = who;
    state.nation = nation;
    stack = ["who"];
    screen = "nation";
    draw();
    var target = document.getElementById("calculator");
    if (target) target.scrollIntoView({ block: "start" });
  }

  window.KTPensionStart = begin;

  function card(onBack) {
    var node = h("div", { class: "kt-card kt-question" });
    if (screen !== "who") node.appendChild(button("Back", "kt-back", onBack || back));
    return node;
  }

  function finish(node) {
    root.textContent = "";
    root.appendChild(node);
    var title = node.querySelector("h3") || node.querySelector("button");
    if (title) {
      if (!title.hasAttribute("tabindex")) title.setAttribute("tabindex", "-1");
      title.focus();
    }
  }

  var liveToken = 0;

  function announce(msg) {
    var live = document.getElementById("kt-step-live");
    if (!live) return;
    liveToken += 1;
    var token = liveToken;
    live.textContent = "";
    setTimeout(function () {
      if (token !== liveToken) return;
      live.textContent = msg;
    }, 30);
  }

  function step(n) {
    announce("Step " + n + " of 7");
    return h("p", { class: "kt-step" }, "Step " + n + " of 7");
  }

  function claimLines(node) {
    node.appendChild(h("p", { class: "kt-p" }, CLAIM));
    node.appendChild(h("p", { class: "kt-p" }, RELAY));
  }

  function savedLine(v) {
    var lead = state.who === "me"
      ? "You may get extra if you (or your partner) reached State Pension age before 6 April 2016 and saved for retirement, for example a personal or workplace pension."
      : "They may get extra if they (or their partner) reached State Pension age before 6 April 2016 and saved for retirement, for example a personal or workplace pension.";
    return lead + " Up to £17.96 a week if single, or £20.10 for a couple.";
  }

  function extraLabel() {
    announce("A few extra questions");
    return h("p", { class: "kt-step" }, "A few extra questions");
  }

  function helper(text) {
    return h("p", { class: "kt-help" }, text);
  }

  function why(text) {
    whySeq += 1;
    var id = "kt-why-" + whySeq;
    var wrap = h("div", { class: "kt-why" });
    var btn = h("button", { type: "button", class: "kt-why-btn", "aria-expanded": "false", "aria-controls": id });
    btn.textContent = "ⓘ Why we ask this ▾";
    var help = h("p", { id: id, class: "kt-why-text" }, text);
    help.hidden = true;
    btn.addEventListener("click", function () {
      var open = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", open ? "false" : "true");
      btn.textContent = open ? "ⓘ Why we ask this ▾" : "ⓘ Why we ask this ▴";
      help.hidden = open;
    });
    wrap.appendChild(btn);
    wrap.appendChild(help);
    return wrap;
  }

  function notSure() {
    var p = h("p", { class: "kt-p" });
    p.appendChild(h("a", { class: "kt-sure", href: "https://www.gov.uk/state-pension-age" }, "Not sure? Check your age on GOV.UK"));
    return p;
  }

  function privacy() {
    return h("p", { class: "kt-privacy" }, PRIVACY);
  }

  function yesNo(fn) {
    var wrap = h("div", { class: "kt-choices" });
    wrap.appendChild(button("Yes", "kt-choice", function () { fn(true); }));
    wrap.appendChild(button("No", "kt-choice", function () { fn(false); }));
    return wrap;
  }

  function linkP(href, text) {
    var p = h("p", { class: "kt-p" });
    p.appendChild(h("a", { href: href }, text));
    return p;
  }

  function drawWho() {
    var node = card();
    node.appendChild(h("h3", { class: "kt-h3" }, "Who is this for?"));
    var wrap = h("div", { class: "kt-choices kt-who" });
    wrap.appendChild(button("Me", "kt-choice", function () { begin("me"); }));
    wrap.appendChild(button("My parent", "kt-choice", function () { begin("parent"); }));
    node.appendChild(wrap);
    node.appendChild(privacy());
    finish(node);
  }

  function drawNation() {
    var node = card();
    node.appendChild(step(1));
    node.appendChild(h("h3", { class: "kt-h3" }, "Where in the UK?"));
    node.appendChild(helper("Rules and phone numbers are a little different in each."));
    var wrap = h("div", { class: "kt-choices kt-choices--stack" });
    [
      ["England", "england"],
      ["Scotland", "scotland"],
      ["Wales", "wales"],
      ["Northern Ireland", "ni"]
    ].forEach(function (pair) {
      wrap.appendChild(button(pair[0], "kt-choice", function () {
        state.nation = pair[1];
        show("spa");
      }));
    });
    node.appendChild(wrap);
    finish(node);
  }

  function drawSpa() {
    var node = card();
    node.appendChild(step(2));
    var ageQ = state.who === "me"
      ? "Have you reached the age you can get your State Pension?"
      : "Have they reached the age they can get their State Pension?";
    node.appendChild(h("h3", { class: "kt-h3" }, ageQ));
    node.appendChild(helper("Most people reach it at 66."));
    node.appendChild(yesNo(function (yes) {
      state.personSpa = yes;
      show("household");
    }));
    node.appendChild(notSure());
    finish(node);
  }

  function drawHousehold() {
    var node = card();
    node.appendChild(step(3));
    node.appendChild(h("h3", { class: "kt-h3" }, "Single or couple?"));
    node.appendChild(helper("Couple means married or living together."));
    var wrap = h("div", { class: "kt-choices" });
    wrap.appendChild(button("Single", "kt-choice", function () {
      state.couple = false;
      state.partnerSpa = null;
      afterAge();
    }));
    wrap.appendChild(button("Couple", "kt-choice", function () {
      state.couple = true;
      show("partner");
    }));
    node.appendChild(wrap);
    finish(node);
  }

  function afterAge() {
    var age = pc.ageOutcome({
      couple: state.couple,
      personSpa: state.personSpa,
      partnerSpa: state.partnerSpa,
      housingBenefit: state.housingBenefit
    });
    if (age === "not_yet") show("not_yet");
    else show("blocks");
  }

  function drawPartner() {
    var v = voice();
    var node = card();
    node.appendChild(step(3));
    node.appendChild(h("h3", { class: "kt-h3" }, "Has " + v.partner + " reached the age for a State Pension?"));
    node.appendChild(helper("Most people reach it at 66."));
    node.appendChild(yesNo(function (yes) {
      state.partnerSpa = yes;
      var age = pc.ageOutcome({
        couple: true,
        personSpa: state.personSpa,
        partnerSpa: yes,
        housingBenefit: null
      });
      if (age === "not_yet") show("not_yet");
      else if (age === "mixed_age") {
        state.housingBenefit = null;
        show("mixed");
      } else show("blocks");
    }));
    node.appendChild(notSure());
    finish(node);
  }

  function drawNotYet() {
    var v = voice();
    var node = card();
    node.classList.add("kt-result");
    node.appendChild(h("h3", { class: "kt-h3" }, "Not yet"));
    node.appendChild(h("p", { class: "kt-lead" }, "Not yet. " + v.You + " can apply up to 4 months before the age for a State Pension."));
    node.appendChild(linkP("https://www.gov.uk/state-pension-age", "Check your age on GOV.UK"));
    node.appendChild(h("p", { class: "kt-p" }, "A claim can be backdated by up to 3 months."));
    claimLines(node);
    addClosing(node, "none");
    finish(node);
  }

  function drawMixed() {
    var v = voice();
    var node = card();
    node.classList.add("kt-result");
    node.appendChild(h("h3", { class: "kt-h3" }, "One of you is under pension age"));
    var line = state.who === "me"
      ? "If one of you is under pension age, you usually can't get Pension Credit unless one of you already gets Housing Benefit (pension age), or you've been entitled to Pension Credit (or Pension Age Housing Benefit) as a couple continuously since before 15 May 2019."
      : "If one of you is under pension age, they usually can't get Pension Credit unless one of them already gets Housing Benefit (pension age), or they've been entitled to Pension Credit (or Pension Age Housing Benefit) as a couple continuously since before 15 May 2019.";
    node.appendChild(h("p", { class: "kt-p" }, line));
    node.appendChild(linkP("https://www.gov.uk/pension-credit/eligibility", "Pension Credit eligibility on GOV.UK"));
    node.appendChild(h("h3", { class: "kt-h3" }, v.Do + " get Housing Benefit (pension age)?"));
    node.appendChild(yesNo(function (yes) {
      state.housingBenefit = yes;
      if (yes) show("blocks");
      else draw();
    }));
    if (state.housingBenefit === false) {
      var keep = state.who === "me"
        ? "Already been entitled to Pension Credit (or Pension Age Housing Benefit) as a couple continuously since before 15 May 2019? You can usually keep it while you stay entitled. Check your Pension Credit letter or call the Pension Service."
        : "Already been entitled to Pension Credit (or Pension Age Housing Benefit) as a couple continuously since before 15 May 2019? They can usually keep it while they stay entitled. Check their Pension Credit letter or call the Pension Service.";
      node.appendChild(h("p", { class: "kt-p" }, keep));
      node.appendChild(linkP("https://www.gov.uk/contact-pension-service", "Pension Service"));
      node.appendChild(h("p", { class: "kt-p" }, "0800 731 0469. Relay UK: 18001 then 0800 731 0469. Welsh: 0800 731 0453. Mon to Fri, 8am to 6pm."));
    }
    addClosing(node, "none");
    finish(node);
  }

  var BLOCKS = [
    ["child", "Responsible for a child"],
    ["selfEmployed", "Self-employed"],
    ["otherProperty", "Owns another property"],
    ["deferring", "Putting off your State Pension"],
    ["careHome", "In a care home"],
    ["abroad", "Currently abroad"],
    ["eu", "From the EU, EEA or Switzerland, without settled or pre-settled status"]
  ];

  function drawBlocks() {
    var v = voice();
    var node = card();
    node.appendChild(step(4));
    node.appendChild(h("h3", { class: "kt-h3" }, "Do any of these apply?"));
    node.appendChild(helper("If one applies, we'll show you where to check instead."));
    node.appendChild(why("A child, self-employment, another property, putting off your State Pension, a care home, being abroad, or EU status without settled or pre-settled status needs a proper check."));
    var wrap = h("div", { class: "kt-choices kt-choices--stack" });
    var anyOn = false;
    BLOCKS.forEach(function (row) {
      var on = !!state.extras[row[0]];
      if (on) anyOn = true;
      var toggle = button(row[1], "kt-choice", function () {
        state.extras[row[0]] = !state.extras[row[0]];
        draw();
      });
      toggle.setAttribute("aria-pressed", on ? "true" : "false");
      wrap.appendChild(toggle);
    });
    node.appendChild(wrap);
    node.appendChild(button(anyOn ? "Next" : "None of these", "kt-btn kt-btn--primary", function () {
      if (!anyOn) BLOCKS.forEach(function (row) { state.extras[row[0]] = false; });
      if (anyOn || routeOn()) show("result");
      else show("income");
    }));
    finish(node);
  }

  function routeOn() {
    return BLOCKS.some(function (row) { return !!state.extras[row[0]]; });
  }

  var INCOME_ROWS = [
    ["sp", "State Pension"],
    ["other", "Other pensions"],
    ["earn", "Earnings after tax"],
    ["ben", "Carer's Allowance or Carer Support Payment"]
  ];

  function drawIncome() {
    var node = card();
    node.appendChild(step(5));
    node.appendChild(h("h3", { class: "kt-h3" }, "What money comes in each week?"));
    node.appendChild(helper("Weekly or monthly is fine. Leave out disability benefits."));
    node.appendChild(why("Do not include Attendance Allowance, PIP, DLA, Council Tax Reduction, Housing Benefit or Winter Fuel Payment. A monthly amount is turned into a week: times 12, divided by 52."));
    INCOME_ROWS.forEach(function (row) {
      var item = state.incomes[row[0]];
      var block = h("div", { class: "kt-row" });
      var toggle = button(row[1], "kt-choice", function () {
        item.on = !item.on;
        if (!item.on) item.raw = "";
        draw();
      });
      toggle.setAttribute("aria-pressed", item.on ? "true" : "false");
      block.appendChild(toggle);
      if (item.on) block.appendChild(amountField(row[0], row[1], item));
      node.appendChild(block);
    });
    if (state.error) node.appendChild(h("p", { class: "kt-error", role: "alert" }, state.error));
    node.appendChild(button("Next", "kt-btn kt-btn--primary", function () {
      if (incomeTotal() == null) {
        state.error = "Enter the amount for each ticked row, or untick it. Use 0 if it is nothing.";
        draw();
        return;
      }
      show("savings");
    }));
    finish(node);
  }

  function amountField(id, label, item) {
    var field = h("div", { class: "kt-field" });
    field.appendChild(h("label", { for: "amt-" + id }, label + " amount"));
    var input = h("input", { id: "amt-" + id, inputmode: "decimal", autocomplete: "off", value: item.raw });
    var note = h("p", { class: "kt-p kt-week-note" }, "");
    function refreshNote() {
      var parsed = item.raw.trim() === "" ? null : pc.parsePoundsToPence(item.raw);
      if (item.period === "month" && parsed != null) {
        note.hidden = false;
        note.textContent = "That's " + formatPence(pc.weeklyFromMonthlyPence(parsed)) + " a week.";
      } else {
        note.hidden = true;
        note.textContent = "";
      }
    }
    input.addEventListener("input", function () {
      item.raw = input.value;
      refreshNote();
    });
    field.appendChild(input);
    var periods = h("div", { class: "kt-choices" });
    periods.appendChild(periodButton(item, "week", "Weekly"));
    periods.appendChild(periodButton(item, "month", "Monthly"));
    field.appendChild(periods);
    field.appendChild(note);
    refreshNote();
    return field;
  }

  function periodButton(item, period, label) {
    var node = button(label, "kt-choice", function () {
      item.period = period;
      draw();
    });
    node.setAttribute("aria-pressed", item.period === period ? "true" : "false");
    return node;
  }

  function incomeTotal() {
    var total = 0;
    var bad = false;
    INCOME_ROWS.forEach(function (row) {
      var item = state.incomes[row[0]];
      if (!item.on) return;
      if (item.raw.trim() === "") {
        bad = true;
        return;
      }
      var parsed = pc.parsePoundsToPence(item.raw);
      if (parsed == null) bad = true;
      else total += item.period === "month" ? pc.weeklyFromMonthlyPence(parsed) : parsed;
    });
    return bad ? null : total;
  }

  function drawSavings() {
    var v = voice();
    var node = card();
    node.appendChild(step(6));
    node.appendChild(h("h3", { class: "kt-h3" }, "What are " + v.your + " savings?"));
    node.appendChild(helper(state.who === "me"
      ? "Bank, building society and ISAs. Not your home."
      : "Bank, building society and ISAs. Not their home."));
    node.appendChild(why("£10,000 or less is ignored. Every £500, or part of £500, over £10,000 counts as £1 a week."));
    var wrap = h("div", { class: "kt-choices kt-choices--stack" });
    wrap.appendChild(button("£10,000 or less", "kt-choice", function () {
      state.savingsOver = false;
      state.savingsPence = 0;
      state.savingsRaw = "0";
      state.gate = null;
      show("gate");
    }));
    wrap.appendChild(button("More than £10,000", "kt-choice", function () {
      state.savingsOver = true;
      show("savingsAmount");
    }));
    node.appendChild(wrap);
    finish(node);
  }

  function drawSavingsAmount() {
    var node = card();
    node.appendChild(step(6));
    node.appendChild(h("h3", { class: "kt-h3" }, "How much are the savings?"));
    node.appendChild(helper("Enter pounds and pence."));
    var field = h("div", { class: "kt-field" });
    field.appendChild(h("label", { for: "savings" }, "Savings amount"));
    var input = h("input", { id: "savings", inputmode: "decimal", autocomplete: "off", value: state.savingsRaw });
    input.addEventListener("input", function () { state.savingsRaw = input.value; });
    field.appendChild(input);
    node.appendChild(field);
    if (state.error) node.appendChild(h("p", { class: "kt-error", role: "alert" }, state.error));
    node.appendChild(button("Next", "kt-btn kt-btn--primary", function () {
      if (state.savingsRaw.trim() === "" || pc.parsePoundsToPence(state.savingsRaw) == null) {
        state.error = "Enter the amount in pounds and pence.";
        draw();
        return;
      }
      state.savingsPence = pc.parsePoundsToPence(state.savingsRaw);
      state.gate = null;
      show("gate");
    }));
    finish(node);
    input.focus();
  }

  function clearCareFlags() {
    ["qbMe", "qbPartner", "livesAlone", "someoneElse", "carerPaidMe", "carerPaidPartner", "blindOther", "carerMe", "carerPartner"].forEach(function (key) {
      state.extras[key] = false;
    });
  }

  function drawGate() {
    var v = voice();
    var node = card();
    node.appendChild(step(7));
    node.appendChild(h("h3", { class: "kt-h3" }, v.Do + " get any disability or carer benefits?"));
    node.appendChild(helper("This can add extra money each week."));
    node.appendChild(why("Extra money for disability, or for caring. We only ask the detail if the answer is yes."));
    var choice = yesNo(function (yes) {
      state.gate = yes;
      if (yes) {
        state.followIndex = 0;
        show("follow");
      } else {
        clearCareFlags();
        draw();
      }
    });
    pressPair(choice, state.gate);
    choice.classList.add("kt-choices--gap");
    node.appendChild(choice);
    if (state.gate === false) {
      endBits(node);
      if (state.error) node.appendChild(h("p", { class: "kt-error", role: "alert" }, state.error));
      node.appendChild(button("Next", "kt-btn kt-btn--primary", function () {
        if (state.extras.housing == null || state.extras.savingsCredit == null) {
          state.error = "Please answer both questions.";
          draw();
          return;
        }
        show("result");
      }));
    }
    finish(node);
  }

  function endBits(node) {
    var v = voice();
    node.appendChild(h("h3", { class: "kt-h3" }, v.Do + " pay ground rent, service charges or site rent?"));
    node.appendChild(helper("Usual for flats or park homes."));
    node.appendChild(yesNo(function (yes) {
      state.extras.housing = yes;
      state.error = "";
      draw();
    }));
    node.appendChild(h("h3", { class: "kt-h3" }, state.who === "me"
      ? "Did you (or your partner) reach State Pension age before 6 April 2016 and have a work or private pension?"
      : "Did they (or their partner) reach State Pension age before 6 April 2016 and have a work or private pension?"));
    node.appendChild(helper(state.who === "me"
      ? "Only if you (or your partner) reached State Pension age before 6 April 2016 and have savings or a second pension."
      : "Only if they (or their partner) reached State Pension age before 6 April 2016 and have savings or a second pension."));
    node.appendChild(yesNo(function (yes) {
      state.extras.savingsCredit = yes;
      state.error = "";
      draw();
    }));
    var groups = node.querySelectorAll(".kt-choices");
    pressPair(groups[groups.length - 2], state.extras.housing);
    pressPair(groups[groups.length - 1], state.extras.savingsCredit);
  }

  function pressPair(group, on) {
    if (!group || on == null) return;
    var buttons = group.querySelectorAll("button");
    if (buttons[0]) buttons[0].setAttribute("aria-pressed", on ? "true" : "false");
    if (buttons[1]) buttons[1].setAttribute("aria-pressed", on ? "false" : "true");
  }

  function followSteps() {
    var v = voice();
    var steps = [
      { id: "qbMe", title: v.Do + " get Attendance Allowance, PIP or DLA?", help: "This can add extra money for disability." }
    ];
    if (state.couple) {
      steps.push({ id: "qbPartner", title: "Does " + v.partner + " get Attendance Allowance, PIP or DLA?", help: "This can add extra money for disability." });
      steps.push({ id: "someoneElse", title: "Does anyone else live there?", help: "This can change the extra for disability." });
      steps.push({ id: "carerPaidMe", title: "Does someone get Carer's Allowance, Carer Support Payment or the Universal Credit carer element for looking after " + v.obj + "?", help: "Say yes if someone gets Carer's Allowance, Carer Support Payment or the Universal Credit carer element for looking after " + v.obj + "." });
      steps.push({ id: "carerPaidPartner", title: "Does someone get Carer's Allowance, Carer Support Payment or the Universal Credit carer element for looking after " + v.partner + "?", help: "Say yes if someone gets Carer's Allowance, Carer Support Payment or the Universal Credit carer element for looking after them." });
      steps.push({ id: "blindOther", title: "Is the other person blind or severely sight impaired?", help: "Only if just one of you gets those benefits.", blind: true });
      steps.push({ id: "carerMe", title: v.Do + " get Carer's Allowance or Carer Support Payment?", help: "This can add extra money for caring." });
      steps.push({ id: "carerPartner", title: "Does " + v.partner + " get Carer's Allowance or Carer Support Payment?", help: "This can add extra money for caring." });
    } else {
      steps.push({ id: "livesAlone", title: v.Do + " live alone?", help: "This can change the extra for disability." });
      steps.push({ id: "carerPaidMe", title: "Does someone get Carer's Allowance, Carer Support Payment or the Universal Credit carer element for looking after " + v.obj + "?", help: "Say yes if someone gets Carer's Allowance, Carer Support Payment or the Universal Credit carer element for looking after " + v.obj + "." });
      steps.push({ id: "carerMe", title: v.Do + " get Carer's Allowance or Carer Support Payment?", help: "This can add extra money for caring." });
    }
    return steps.filter(function (stepItem) {
      if (!stepItem.blind) return true;
      return !!state.extras.qbMe !== !!state.extras.qbPartner;
    });
  }

  function drawFollow() {
    var steps = followSteps();
    if (state.followIndex >= steps.length) state.followIndex = Math.max(0, steps.length - 1);
    var stepItem = steps[state.followIndex];
    var node = card(function () {
      if (state.followIndex > 0) {
        state.followIndex -= 1;
        draw();
      } else back();
    });
    node.appendChild(extraLabel());
    node.appendChild(h("h3", { class: "kt-h3" }, stepItem.title));
    if (stepItem.help) node.appendChild(helper(stepItem.help));
    if (stepItem.id === "qbMe") {
      node.appendChild(why("Also Pension Age Disability Payment, Adult Disability Payment, or Armed Forces Independence Payment. Conditions apply."));
    }
    node.appendChild(yesNo(function (yes) {
      state.extras[stepItem.id] = yes;
      state.followIndex += 1;
      var next = followSteps();
      if (state.followIndex >= next.length) {
        screen = "tail";
        draw();
      } else draw();
    }));
    finish(node);
  }

  function drawTail() {
    var node = card(function () {
      state.followIndex = Math.max(0, followSteps().length - 1);
      screen = "follow";
      draw();
    });
    node.appendChild(extraLabel());
    endBits(node);
    if (state.error) node.appendChild(h("p", { class: "kt-error", role: "alert" }, state.error));
    node.appendChild(button("Next", "kt-btn kt-btn--primary", function () {
      if (state.extras.housing == null || state.extras.savingsCredit == null) {
        state.error = "Please answer both questions.";
        draw();
        return;
      }
      show("result");
    }));
    finish(node);
  }

  function resultModel() {
    var income = incomeTotal();
    if (income == null) return null;
    return pc.calculate({
      couple: !!state.couple,
      incomePence: income,
      savingsPence: state.savingsPence,
      qbMe: !!state.extras.qbMe,
      qbPartner: !!state.extras.qbPartner,
      livesAlone: !!state.extras.livesAlone,
      noOneElse: !state.extras.someoneElse,
      carerPaidMe: !!state.extras.carerPaidMe,
      carerPaidPartner: !!state.extras.carerPaidPartner,
      blindOther: !!state.extras.blindOther,
      carerMe: !!state.extras.carerMe,
      carerPartner: !!state.extras.carerPartner,
      housingCosts: !!state.extras.housing,
      savingsCreditFlag: !!state.extras.savingsCredit,
      selfEmployed: !!state.extras.selfEmployed,
      otherProperty: !!state.extras.otherProperty,
      deferring: !!state.extras.deferring,
      careHome: !!state.extras.careHome,
      abroad: !!state.extras.abroad,
      child: !!state.extras.child,
      euUnsure: !!state.extras.eu
    });
  }

  function drawResult() {
    if (routeOn()) {
      drawRoute();
      return;
    }
    var income = incomeTotal();
    if (income == null) {
      screen = "income";
      state.error = "Enter the amount for each ticked row, or untick it. Use 0 if it is nothing.";
      draw();
      return;
    }
    var model = resultModel();
    var v = voice();
    var node = card();
    node.classList.add("kt-result");
    var tiny = model.outcome === "estimate" && model.displayWeeklyPence < 5;
    var outcome = tiny ? "close" : model.outcome;
    node.appendChild(h("h3", { class: "kt-h3" }, "Result"));
    if (outcome === "estimate") {
      node.appendChild(h("p", { class: "kt-lead" }, v.You + " could get about " + formatPence(model.displayWeeklyPence) + " a week, about " + formatPence(model.displayAnnualPence) + " a year."));
      node.appendChild(h("p", { class: "kt-p" }, "This can be backdated by up to 3 months."));
    } else if (outcome === "close") {
      node.appendChild(h("p", { class: "kt-lead" }, "Very close. Small differences matter, so check with GOV.UK."));
      node.appendChild(linkP("https://www.gov.uk/pension-credit-calculator", "GOV.UK Pension Credit calculator"));
    } else {
      node.appendChild(h("p", { class: "kt-lead" }, "Pension Credit looks unlikely from these answers."));
      plainFlags(node, model, v);
      node.appendChild(linkP("https://www.gov.uk/pension-credit-calculator", "GOV.UK Pension Credit calculator"));
    }
    if (outcome !== "unlikely") {
      flags(node, model, v);
      unlocks(node);
    }
    howToApply(node);
    node.appendChild(h("p", { class: "kt-p" }, "This is an estimate, not a decision. Only DWP (or the NI Pension Centre) can decide."));
    node.appendChild(h("p", { class: "kt-p" }, "Rates checked against GOV.UK by the HelpAlert team."));
    node.appendChild(h("p", { class: "kt-checked" }, "Last checked 12 Oct 2026"));
    sources(node);
    addClosing(node, outcome === "estimate" ? "full" : "none");
    finish(node);
  }

  function drawRoute() {
    var v = voice();
    var node = card();
    node.classList.add("kt-result");
    node.appendChild(h("h3", { class: "kt-h3" }, "Your situation needs a proper check"));
    var because = {
      child: "responsible for a child",
      selfEmployed: "self-employed",
      otherProperty: v.you === "you" ? "own another property" : "own another property",
      deferring: "putting off your State Pension",
      careHome: "in a care home",
      abroad: "currently abroad",
      eu: "from the EU, EEA or Switzerland without settled or pre-settled status"
    };
    BLOCKS.forEach(function (row) {
      if (!state.extras[row[0]]) return;
      var reason = because[row[0]];
      var line = state.who === "me"
        ? "Because you're " + reason + ", we can't estimate this one accurately, but you may still qualify."
        : "Because they're " + reason + ", we can't estimate this one accurately, but they may still qualify.";
      if (row[0] === "otherProperty") {
        line = state.who === "me"
          ? "Because you own another property, we can't estimate this one accurately, but you may still qualify."
          : "Because they own another property, we can't estimate this one accurately, but they may still qualify.";
      }
      if (row[0] === "child") {
        line = state.who === "me"
          ? "Because you're responsible for a child, we can't estimate this one accurately, but you may still qualify."
          : "Because they're responsible for a child, we can't estimate this one accurately, but they may still qualify.";
      }
      node.appendChild(h("p", { class: "kt-p" }, line));
    });
    node.appendChild(linkP("https://www.gov.uk/pension-credit-calculator", "GOV.UK Pension Credit calculator"));
    if (state.nation === "ni") {
      node.appendChild(linkP("https://www.nidirect.gov.uk/articles/get-pension-credit-estimate", "Northern Ireland estimate tool"));
      node.appendChild(h("p", { class: "kt-p" }, "Pension Credit Application Line: 0808 100 6165 (free). Mon–Fri 9am–4pm. Relay UK: 18001 then 0808 100 6165."));
    } else {
      claimLines(node);
    }
    unlocks(node);
    addClosing(node, "none");
    finish(node);
  }

  function plainFlags(node, model, v) {
    if (model.flags.indexOf("savings_credit") !== -1) {
      node.appendChild(h("p", { class: "kt-p" }, savedLine(v)));
    }
    if (model.flags.indexOf("sda") !== -1 || model.flags.indexOf("disability_check") !== -1) {
      node.appendChild(h("p", { class: "kt-p" }, "You may get extra money for disability. Check with GOV.UK."));
    }
    if (model.flags.indexOf("housing") !== -1) {
      node.appendChild(h("p", { class: "kt-p" }, v.You + " may get more for ground rent/service charges."));
    }
  }

  function flags(node, model, v) {
    if (model.flags.indexOf("housing") !== -1) {
      node.appendChild(h("p", { class: "kt-p" }, v.You + " may get more for ground rent/service charges."));
    }
    if (model.flags.indexOf("savings_credit") !== -1) {
      node.appendChild(h("p", { class: "kt-p" }, savedLine(v)));
    }
    if (model.flags.indexOf("sda") !== -1) {
      node.appendChild(h("p", { class: "kt-p" }, v.You + " may get " + formatPence(model.sdaPence) + " extra for disability."));
    }
    if (model.flags.indexOf("disability_check") !== -1) {
      node.appendChild(h("p", { class: "kt-p" }, v.You + " may still get extra money for disability. Check with GOV.UK."));
    }
  }

  function unlocks(node) {
    node.appendChild(h("h3", { class: "kt-h3" }, "What Pension Credit can unlock"));
    var list = h("ul", { class: "kt-list" });
    list.appendChild(h("li", null, "Housing Benefit (if renting)"));
    list.appendChild(h("li", null, "Support for Mortgage Interest (if owning)"));
    list.appendChild(h("li", null, state.nation === "ni" ? "Rates Relief" : "Council Tax Reduction"));
    list.appendChild(h("li", null, state.nation === "scotland" ? "Winter Heating Payments" : "Cold Weather Payments, automatic"));
    var tv = h("li", null, "");
    tv.appendChild(document.createTextNode("Free TV licence if 75 or over. "));
    tv.appendChild(h("a", { href: "https://www.gov.uk/free-discount-tv-licence" }, "GOV.UK free TV licence"));
    list.appendChild(tv);
    list.appendChild(h("li", null, "Help with NHS dental treatment, glasses and travel to hospital (not if you only get the extra for savers)."));
    list.appendChild(h("li", null, "Warm Home Discount"));
    list.appendChild(h("li", null, "Royal Mail redirection discount"));
    node.appendChild(list);
    if (state.nation !== "scotland") {
      node.appendChild(linkP("https://www.gov.uk/cold-weather-payment", "Cold Weather Payment on GOV.UK"));
    }
  }

  function howToApply(node) {
    node.appendChild(h("h3", { class: "kt-h3" }, "How to apply"));
    node.appendChild(h("p", { class: "kt-p" }, "We never apply on your behalf."));
    if (state.nation === "ni") {
      node.appendChild(linkP("https://www.nidirect.gov.uk/articles/applying-pension-credit", "Apply on nidirect"));
      node.appendChild(h("p", { class: "kt-p" }, "Pension Credit Application Line: 0808 100 6165 (free). Mon–Fri 9am–4pm. General enquiries: 0800 587 0892. Relay UK: 18001 then the number."));
      node.appendChild(linkP("https://www.nidirect.gov.uk/articles/get-pension-credit-estimate", "Northern Ireland estimate tool"));
    } else {
      claimLines(node);
      node.appendChild(linkP("https://www.gov.uk/pension-credit/how-to-claim", "How to claim on GOV.UK"));
    }
    node.appendChild(h("p", { class: "kt-p" }, "Citizens Advice or Age UK can help with the form. GOV.UK names them."));
    node.appendChild(h("p", { class: "kt-p" }, "You can apply up to 4 months before the age for a State Pension. A claim can be backdated by up to 3 months."));
  }

  function sources(node) {
    node.appendChild(h("h3", { class: "kt-h3" }, "Sources"));
    var list = h("ul", { class: "kt-list kt-sources" });
    [
      ["https://www.gov.uk/pension-credit/what-youll-get", "What you'll get"],
      ["https://www.gov.uk/pension-credit/eligibility", "Eligibility"],
      ["https://www.gov.uk/pension-credit/how-to-claim", "How to claim"],
      ["https://www.gov.uk/government/publications/pension-credit-technical-guidance/a-detailed-guide-to-pension-credit-for-advisers-and-others", "DWP adviser guide"],
      ["https://www.gov.uk/contact-pension-service", "Contact the Pension Service"],
      ["https://www.nidirect.gov.uk/articles/understanding-pension-credit", "nidirect: understanding Pension Credit"],
      ["https://www.nidirect.gov.uk/articles/applying-pension-credit", "nidirect: applying"]
    ].forEach(function (pair) {
      var li = h("li");
      li.appendChild(h("a", { href: pair[0] }, pair[1]));
      list.appendChild(li);
    });
    node.appendChild(list);
  }

  function addClosing(node, mode) {
    node.appendChild(button("Print or save as PDF", "kt-btn kt-btn--ghost", function () { window.print(); }));
    node.appendChild(privacy());
    var offer = h("div", { class: "kt-alarm-offer" });
    if (mode === "full") {
      var alarm = h("aside", { class: "kt-alarm", "aria-label": "Personal alarm" });
      alarm.appendChild(h("h3", { class: "kt-h3" }, "Worried about someone living alone?"));
      alarm.appendChild(h("p", null, "HelpAlert alarms are monitored 24/7 by our UK team."));
      alarm.appendChild(h("a", { class: "kt-btn kt-btn--ghost", href: "/pages/free-trial" }, "Start a free trial"));
      offer.appendChild(alarm);
      node.appendChild(offer);
    }
  }

  function draw() {
    var busy = screen !== "who" && screen !== "not_yet" && screen !== "result";
    document.body.classList.toggle("kt-busy", busy);
    if (screen === "who") drawWho();
    else if (screen === "nation") drawNation();
    else if (screen === "spa") drawSpa();
    else if (screen === "household") drawHousehold();
    else if (screen === "partner") drawPartner();
    else if (screen === "not_yet") drawNotYet();
    else if (screen === "mixed") drawMixed();
    else if (screen === "blocks") drawBlocks();
    else if (screen === "income") drawIncome();
    else if (screen === "savings") drawSavings();
    else if (screen === "savingsAmount") drawSavingsAmount();
    else if (screen === "gate") drawGate();
    else if (screen === "follow") drawFollow();
    else if (screen === "tail") drawTail();
    else drawResult();
  }

  var startBtn = document.getElementById("kt-start");
  if (startBtn) startBtn.addEventListener("click", function () { begin("me"); });
  var mumBtn = document.getElementById("kt-mum");
  if (mumBtn) mumBtn.addEventListener("click", function () { begin("parent"); });

  var calc = document.getElementById("calculator");
  if (calc && "IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      document.body.classList.toggle("kt-calc-on", entries[0].isIntersecting);
    }).observe(calc);
  }

  draw();
})();
